module.exports = __webpack_public_path__ + "img/colombe.8dca6eda.jpg";